export default "assets/dragon-graphic-320-CjvJ5Hey.webp"